<template>
  <div>
    <header id="darkModeHeader" class="mdc-top-app-bar darkModeHeader">
      <div class="d-flex align-items-center pdl-24 pdr-24 justify-conetent-between h-full">
        <div
            class="t-subtitle3 t-color-whiteHigh  d-flex align-items-center pdr-24 font-r t-line-1 mgr-30">
          {{ lessonName }}
        </div>
        <div class="d-flex align-items-center justify-content-end flex-grow-1">
          <div class="position-relative w-80 mgr-24">
            <div class="percentage-wrapper">
              <div class="h-2 position-relative total-percentage  bg-whiteBorder h-4">
                <div :style="{width: rate+'%'}"
                     class="real-percentage bg-saleLine b-radius0 h-4 mgt-2">
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-baseline mgr-24 t-nowrap">
            <div
                class="t-headline10 t-color-whiteHigh t-line-h-15 d-flex align-items-center  font-b">
              {{ rate }}
            </div>
            <div class="t-body3 font-m mgl-4 t-color-whiteHigh">%</div>
          </div>
          <button
              class="mdc-button mdc-button--outlined mdc-button--raised t-color-secondaryBtnText videoHeaderBtn b-radius4  pdl-12 pdr-12" tabindex="0"
              @click="moveLearnViewClose()" @keypress="moveLearnViewClose()">
            <span class="mdc-button__ripple"></span>
            <span class="mdc-button__label t-body2 font-r t-color-whiteHigh t-nowrap">{{ $t('3182') }}</span>
          </button>
        </div>
      </div>
      <div v-if="lightModeActive" class="divider"></div>
    </header>

    <!-- <div class="d-flex slide-slider bg-contentPlayerBg  width-learning-object"  > -->
    <div class="position-reltive">
      <image-slider
          v-if="slideFiles.length"
          id="wrap-slide-contents"
          ref="imageSlide"
          :isAllPages="isAllPages"
          :isIndex="isIndex"
          :isLearningObjective="isLearningObjective"
          :isQuestionAns="isQuestionAns"
          :isResources="isResources"
          :isScroll="isScroll"
          :isTimeline="isTimeline"
          :islightModeActive="lightModeActive"
          :last="last"
          :learnId="this.$route.params.learnId"
          :lesson="lessonData"
          :lessonId="this.$route.params.lessonId"
          :personalInfo="personalInfo"
          :progressionId="this.$route.params.progressionId"
          :recent="recent"
          :slideFiles="slideFiles"
          :time="time"
          @closeImageNav="closeImageNav"
          @setisLearningObjective="setisLearningObjective"
          @setisQuestionAns="setisQuestionAns"
          @setisResources="setisResources"
          @updateEndedLesson="updateEndedLesson"
          @updateProgress="updateProgress"
          @zoomOut="zoomOut"
      ></image-slider>

      <div v-if="endedLesson && nextLesson">
        <div v-if="isIndex" :style="isIndex  ? 'right:320px' : 'right:10px'"
             class="d-flex justify-content-end w-full mgb-26 intro-button position-absolute">
          <button id="hideButton" ref="hideButton" class="mdc-button bg-white t-color-headlineBlack b-radius4" tabindex="0"
                  @click="moveNextLesson(nextLesson)" @keypress="moveNextLesson(nextLesson)">
            <span class="mdc-button__ripple"></span>
            <i aria-hidden="true" class="material-icons mdc-button__icon">play_arrow</i>
            <span class="mdc-button__label t-body2 font-r">{{ $t('959') }}{{ ': ' + nextLesson.name }}</span>
            <span class="video-btn-overlay"></span>
          </button>
        </div>
        <div v-else :style="(isLearningObjective ||isQuestionAns) ? 'right:474px' : 'right:50px'"
             class="d-flex justify-content-end w-full mgb-26 intro-button position-absolute">
          <button id="hideButton" ref="hideButton" class="mdc-button bg-white t-color-headlineBlack b-radius4" tabindex="0"
                  @click="moveNextLesson(nextLesson)" @keypress="moveNextLesson(nextLesson)">
            <span class="mdc-button__ripple"></span>
            <i aria-hidden="true" class="material-icons mdc-button__icon">play_arrow</i>
            <span class="mdc-button__label t-body2 font-r">{{ $t('959') }}{{ ': ' + nextLesson.name }}</span>
            <span class="video-btn-overlay"></span>
          </button>
        </div>
      </div>

      <div v-if="endedLesson && !nextLesson && isConsistExam">
        <div v-if="isIndex" :style=" isIndex ? 'right:320px' : 'right:10px'"
             class="d-flex justify-content-end w-full mgb-26 intro-button position-absolute">
          <button class="mdc-button bg-white t-color-headlineBlack b-radius4" tabindex="0"
                  @click="moveNextLesson(nextLesson)" @keypress="moveNextLesson(nextLesson)">
            <span class="mdc-button__ripple"></span>
            <i aria-hidden="true" class="material-icons mdc-button__icon">play_arrow</i>
            <span class="mdc-button__label t-body2 font-r">{{ $t('3187') }}</span>
            <span class="video-btn-overlay"></span>
          </button>
        </div>
        <div v-else :style="(isLearningObjective ||isQuestionAns) ? 'right:474px' : 'right:50px'"
             class="d-flex justify-content-end w-full mgb-26 intro-button position-absolute">
          <button class="mdc-button bg-white t-color-headlineBlack b-radius4" tabindex="0"
                  @click="moveNextLesson(nextLesson)" @keypress="moveNextLesson(nextLesson)">
            <span class="mdc-button__ripple"></span>
            <i aria-hidden="true" class="material-icons mdc-button__icon">play_arrow</i>
            <span class="mdc-button__label t-body2 font-r">{{ $t('3187') }}</span>
            <span class="video-btn-overlay"></span>
          </button>
        </div>
      </div>
    </div>
    <!-- </div> -->


    <div class="slider-footer ">
      <div class="range-slider range-slider__range">
        <div :style="`width:${progressBar}%;`" class="home-progressbar video-status position-absolute"></div>
      </div>
      <div v-if="lightModeActive" class="divider"></div>
      <div :class="lightModeActive ? '':'bg-contentPlayerBg'" class="d-grid-3 footer-learning">
        <div class="pdl-50 pdt-4 d-flex align-items-center">
          <span tabindex="0" @click="darkModeToLight()" @keypress="darkModeToLight()">
            <img :src="lightModeActive?'/img/lightModeFixedButton.png':'/img/darkModeFixedButton.svg'" alt="theme toggle"
              class="cursor-pointer w-32 h-32"></span>
          <span class="d-inline-block bg-whiteBorder w-1 h-28 mgl-24 mgr-24"></span>
          <a :class="zoomValue<=100?'disAbledPlusAndMinus':''" :disabled="zoomValue<=100?'disabled':''" class="cursor-pointer" tabindex="0"
             @click="zoomOut" @keypress="zoomOut"><img
              :src="lightModeActive ?'/img/zoon-minus-light.png':'/img/zoon-minus.png'" alt="Zoom Out"
              class="w-32 h-32"></a>
          <span class="pdl-24 t-color-whiteHigh t-subtitle5 pdr-24 t-nowrap">{{ zoomValue }}%</span>
          <a :class="zoomValue>=200?'disAbledPlusAndMinus':''" :disabled="zoomValue>=200?'disabled':''" class="cursor-pointer" tabindex="0"
             @click="zoomIn" @keypress="zoomIn"><img
              :src="lightModeActive ?  '/img/zoom-plus-light.png' : '/img/zoom-plus.png'" alt="Zoom In"
              class="w-32 h-32"></a>
        </div>
        <div class="d-flex pdt-4 align-items-center justify-content-center">
          <div class="t-color-whiteHigh t-subtitle5 mgl-8"> {{ currentSlide }}</div>
          <div class="t-color-whiteMedium t-subtitle5 mgl-8 t-nowrap"> / {{ slideFiles.length }}</div>
        </div>
        <div class="d-flex pdt-4 align-items-center justify-content-end mgr-50">
          <div class="d-flex align-items-center">
            <button
                :class="likes ? 't-color-red' : 't-color-whiteDisabled'" class="material-icons mdc-icon-button  l-icon mgl--12 "
                tabindex="0"
                @click="onLike" @keypress="onLike">favorite
            </button>
            <span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ likesCount }}</span>
          </div>
          <div class="d-flex align-items-center mgl-24 mgr-24">
            <button
                :class="clipping ? 't-color-contentBlue' : 't-color-whiteDisabled'" class="material-icons mdc-icon-button  l-icon mgl--12 "
                tabindex="0"
                @click="onBookmark" @keypress="onBookmark">bookmark
            </button>
            <span class="t-body6 t-color-whiteHigh font-rn pdl-8">{{ clippingCount }}</span>
          </div>

          <span class="cursor-pointer"><img :src="lightModeActive?'/img/information-light.png':'/img/information.png'"
                                            alt="information" class="l-icon" tabindex="0"
                                            @click="setisLearningObjective(),closeImageNav()" @keypress="setisLearningObjective(),closeImageNav()"></span>

          <span class="cursor-pointer" tabindex="0" @click="openNav" @keypress="openNav"><img
              :src="lightModeActive?'/img/list-icon-light.svg':'/img/list-icon.svg'" alt="list slides"
              class="l-icon mgl-24 mgr-24  rtl-support"></span>

          <button :class=" lightModeActive  ? 'bg-contentPlayerBgLight' : 'bg-secondaryBtn'"
                  class="mdc-button  mdc-button--raised  t-color-contentText min-w-auto " tabindex="0"
                  @click="setisQuestionAns(),closeImageNav()" @keypress="setisQuestionAns(),closeImageNav()">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r t-nowrap">{{ $t('3184') }}</span>
          </button>
        </div>

      </div>
    </div>

    <!-- 퀴즈 팝업 -->
    <timeline-quiz-pop v-if="isTimelineQuiz" :currentTimelineContents="currentTimelineContents"
            @closeQuizPop="closeQuizPop()" @openQuizDetail="openQuizDetail()" />

    <timeline-quiz-detail v-if="isQuizVisible" :currentTimelineContents="currentTimelineContents"
      :lightModeActive="lightModeActive" @closeQuizDetail="closeQuizDetail()" />

    <!-- 리소스 팝업 -->
    <timeline-resource-pop v-if="isTimelineResource" :currentTimelineContents="currentTimelineContents"
      @closeResource="closeResource()" @openResource="openResource()" />
  </div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - 슬라이드 이미지 컨텐츠 컴포넌트(my learning lesson study - slide image content component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import ImageSlider from './slider/ImageSlider.vue'
import {slideTypeMixins} from '@/mixins/slideType.js'
import LessonsList from './LessonsList.vue'

import TimelineQuizPop from "./TimelineQuizPop.vue";
import TimelineQuizDetail from "./TimelineQuizDetail.vue";
import TimelineResourcePop from "./TimelineResourcePop.vue";
import LikeAndBookmark from "./LikeAndBookmark.vue";

import {MDCRipple} from '@material/ripple'

export default {
  data() {
    return {
      slideFiles: [],
      lessonData: null,
      lessonName: '',
      lessonsList: [],
      nextLessonName: '',
      currentProgressionId: '',
      rate: 0,
      last: 0,
      recent: 0,
      time: 0,
      currentSlide: 0,
      showLectureList: false,
      nextLesson: '',

      // 북마크 좋아요 관려 데이터(like & bookmark data)
      isLiked: false,
      isBookmarked: false,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,

      isAllPages: false,
      isScroll: false,
      isTimeline: false,

      endedLesson: false,

      personalInfo: null,
      progressBar: 0,
      zoomValue: 100,
      isIndex: false,
      questionChat: '',
      lightModeActive: false,
      timerId: null,
			isConsistExam: true,

      //타임라인 관련 데이터(timeline data)
      isTimelineQuiz: false,
      isTimelineResource: false,
      timelineContents: [],
      currentTimelineContents: null,
    }
  },

  components: {
    'image-slider': ImageSlider,
    'lessons-list': LessonsList,
    'timeline-quiz-pop': TimelineQuizPop,
    'timeline-quiz-detail': TimelineQuizDetail,
    'timeline-resource-pop': TimelineResourcePop,
    // 'pop-next-lesson' : PopNextLesson,
    'like-and-bookmark': LikeAndBookmark,
  },

  mixins: [slideTypeMixins],

  computed: {
    swiper() {
      return this.$refs.previewSwiper.swiper
    },
  },
  mounted() {
    const article = document.querySelector('html');
    const modeContent = article.getAttribute("data-theme");
    if (localStorage.getItem('themeMode')) {
      article.setAttribute("data-theme", localStorage.getItem('themeMode'));
      this.lightModeActive = localStorage.getItem('themeMode') == 'dark' ? false : true;
    } else {
      if (modeContent == "dark")
        this.lightModeActive = false;
      else
        this.lightModeActive = true;
    }
    //this.$showLoading(this.$refs.slideContainer)
    let params = this.setParams()
    let responseData = null
    //this.setMaterialUi()
    //차시 컨텐츠 정보 API 호출(get lesson contents data)
    learnApi.learnLessonContents(params).then((response) => {
      responseData = response.data.data
      this.lessonData = responseData
      this.lessonName = this.lessonData.lessonName
      this.rate = this.lessonData.rate
      this.slideFiles = this.lessonData.slide.files.filter(url => !url.includes("__MACOSX"))
      this.last = this.lessonData.last
      this.recent = this.lessonData.recent
      this.currentProgressionId = this.lessonData.progressionId
      this.time = this.lessonData.slide.time

      this.likes = this.lessonData.likes
      this.likesCount = this.lessonData.likesCount
      this.clipping = this.lessonData.clipping
      this.clippingCount = this.lessonData.clippingCount

      this.fetchLectureList()

    }).catch((err) => {
    })


    // 타임라인 컨텐츠 정보 API 호출(get timeline data)
    learnApi.learnLessonTimelinecontents(params).then((response) => {
      responseData = response.data.data
      this.timelineContents = responseData
    }).catch((err) => {
    })

    learnApi.getMemberInfo().then((response) => {
      this.personalInfo = response.data.data
    })

		this.getExamInfo();
  },

  beforeDestroy() {
    document.removeEventListener("mousemove", this.eventHandler)
    document.removeEventListener("keydown", this.eventHandler)
  },

  methods: {
    eventHandler() {
      const hideButton = document.querySelector('#hideButton');
      if (hideButton) {
        hideButton.style.display = 'none';
      }
      clearTimeout(this.timerId);
    },
    // set light and dark mode
    darkModeToLight() {
      const article = document.querySelector('html');
      const modeContent = article.getAttribute("data-theme");
      localStorage.setItem('themeMode', modeContent == "dark" ? "light" : "dark");
      article.setAttribute("data-theme", modeContent == "dark" ? "light" : "dark");
      this.lightModeActive = !this.lightModeActive;
    },
    // open slide nav
    openNav() {
      if (this.isIndex == false) {
        this.isIndex = true
        document.getElementById("gallery-thumbs-container").style.marginRight = "0";
        document.querySelector('.slide-slider').classList.add("indexed")
      } else {
        this.isIndex = false
        document.getElementById("gallery-thumbs-container").style.marginRight = "-300px";
        document.querySelector('.slide-slider').classList.remove("indexed")
      }
      this.closeAllSidebar();
    },
    closeImageNav() {
      this.isIndex = false
      document.getElementById("gallery-thumbs-container").style.marginRight = "-300px";
      document.querySelector('.slide-slider').classList.remove("indexed")
    },
    toggleAllpageOpen() {
      this.isAllPages = true;
    },
    toggleAllpageClose() {
      this.isAllPages = false;
    },

    // zoomin image
    zoomIn() {
      this.zoomValue = parseInt(this.zoomValue) + 100 > 200 ? 200 : 200
      if (this.zoomValue == 200) {
        this.zoomValue = 200
        this.$refs.imageSlide.zoomInHandler()
      }
    },

    // zoom out image
    zoomOut() {
      this.zoomValue = parseInt(this.zoomValue) - 100 > 100 ? 100 : 100
      if (this.zoomValue == 100) {
        this.zoomValue = 100
        this.$refs.imageSlide.zoomOutHandler()
      }
    },

    changeSlideIndex(index) {
      this.currentSlide = index
      this.$refs.imageSlide.changeSlideIndexChild(index)
    },

    setLikeAndBookParams() {
      let params = {
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },
    // setlike count
    onLike() {
      let params = this.setLikeAndBookParams();
      let responseData = null;
      if (this.likes) {
        learnApi
            .learnLessonLikesDelete(params)
            .then((response) => {
              responseData = response.data.data;
              this.likes = response.data.data;
              this.likesCount = this.likesCount - 1;

            })
            .catch((err) => {
            });
      } else {
        learnApi
            .learnLessonLikesPost(params)
            .then((response) => {
              //this.heartcolor={'color':'var(--secondaryBtnText) !important'}
              responseData = response.data.data;
              this.likes = response.data.data;
              this.likesCount = this.likesCount + 1;
            })
            .catch((err) => {
            });
      }
    },

    // 북마크 API 호출(set/cancel bookmark)
    onBookmark() {
      let params = this.setParams();
      let responseData = null;
      if (this.clipping) {
        learnApi
            .learnLessonClippingDelete(params)
            .then((response) => {
              responseData = response.data.data;
              this.clipping = responseData;
              this.clippingCount = this.clippingCount - 1
              this.toggleBookmarkIcon();
            })
            .catch((err) => {
            });
      } else {
        learnApi
            .learnLessonClippingPost(params)
            .then((response) => {
              responseData = response.data.data;
              this.clipping = responseData;
              this.clippingCount = this.clippingCount + 1
            })
            .catch((err) => {
            });
      }
    },
    // End lesson
    updateEndedLesson(value) {
      this.endedLesson = value
      if (value === true) {
        let myLession = this.nextLesson;
        let myRoute = this.$route;
        let myRouter = this.$router;
        this.timerId = setTimeout(function () {
          let learnId = myRoute.params.learnId;
          let status = myRoute.query.status;
          if(myLession && myLession.contentsType && myLession.contentsType.value === 'VIDEO') {
            myRouter.push(`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=`+status)
          } else if(myLession && myLession.contentsType && myLession.contentsType.value === 'EXAM_PAPER') {
            myRouter.push(`/learn/${learnId}/lessonExam/${myLession.examineeId}/intro?status=`+status)
          } else if(myLession && myLession.contentsType && myLession.contentsType.value === 'PDF') {
            myRouter.push(`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=`+status)
          } else if(myLession && myLession.contentsType && myLession.contentsType.value === 'SLIDE') {
            myRouter.push(`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=`+status)
          } else if (myLession && myLession.contentsType && myLession.contentsType.value === 'HTML') {
            myRouter.push(`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` + status)
          } else if (myLession && myLession.contentsType && myLession.contentsType.value === 'INTERACTIVE_HTML') {
            myRouter.push(`/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` + status)
          } else if(myLession && myLession.contentsType && myLession.contentsType.value === 'LIVE_SESSION') {
            self.liveLessonPopup(myLession,myRoute,myRouter)
          } else {
            myRouter.push(`/learn/${learnId}?status=`+status)
          }
        }, 5000);

        document.addEventListener("mousemove", this.eventHandler)
        document.addEventListener("keydown", this.eventHandler)
      }
    },

    moveNextLesson(lesson) {
      let learnId = this.$route.params.learnId
      let status = this.$route.query.status
      if(lesson && lesson.contentsType && lesson.contentsType.value === 'VIDEO') {
        this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=`+status)
      } else if(lesson && lesson.contentsType && lesson.contentsType.value === 'EXAM_PAPER'){
        this.$router.push(`/learn/${learnId}/lessonExam/${lesson.examineeId}/intro?status=`+status)
      }else if(lesson && lesson.contentsType && lesson.contentsType.value === 'PDF'){
        this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=`+status)
      } else if(lesson && lesson.contentsType && lesson.contentsType.value === 'SLIDE'){
        this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=`+status)
      } else if (lesson && lesson.contents && lesson.contents.lcms && lesson.contents.lcms.type && lesson.contents.lcms.type.value === 'HTML') {
        this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` + status)
      } else if (lesson && lesson.contents && lesson.contents.lcms && lesson.contents.lcms.type && lesson.contents.lcms.type.value === 'INTERACTIVE_HTML') {
        this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` + status)
      } else if(lesson && lesson.contentsType && lesson.contentsType.value === 'LIVE_SESSION'){
        let params = {
          learnId: this.$route.params.learnId,
          progressionId: lesson.progressionId
        }
        learnApi.learnLessonContents(params).then((response) => {
          let liveSessionTrueFalse = response.data.data.liveSession.canParticipate
          if(liveSessionTrueFalse === false) {
            this.$alert({
              title: this.$t("3434"), // 학습을 중단한 강의입니다.
              content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
              accept: this.$t("3436"), // 확인
            }).then(() => {}).catch(() => {});
          } else {
            this.$router.push({
              name: "LessonView",
              params: {
                learnId: this.$route.params.learnId,
                lessonId: lesson.id,
                progressionId: lesson.progressionId,
              },
              query: this.$route.query,
            });
          }
        }).catch((err) => {
        })
      } else {
        this.$router.push(`/learn/${learnId}?status=`+status)
      }
    },
    // 진도저장 API 호출(update progress)
    updateProgress(currentIndex) {

      if (this.zoomValue > 100) {
        this.zoomValue = 100
        this.$refs.imageSlide.zoomInHandler()
      }
      if (currentIndex) {
        this.currentSlide = currentIndex + 1
      } else {
        this.currentSlide = 1
      }

      // if(this.currentSlide === 1){
      //     this.progressBar = 0;
      // } else {
      //     let progressBarLength = Math.floor(this.currentSlide*100/this.slideFiles.length)
      //     this.progressBar = progressBarLength;
      // }
      let progressBarLength = Math.floor(this.currentSlide * 100 / this.slideFiles.length)
      this.progressBar = progressBarLength;

      let params = this.setParams()
      let responseData = null

      learnApi.learnLessonProgression(params).then((response) => {
        responseData = response.data.data
        this.rate = responseData.rate
        this.last = responseData.last
      }).catch((err) => {
      })

      if (!this.isPortrait) {
        this.moveScrollVerticalList(currentIndex)
      }


      // Timeline logic
      let findTimelineContents = _.find(this.timelineContents, (content) => {
        return parseInt(content.position) === this.currentSlide
      })

      let isChange = false
      if (findTimelineContents) {
        isChange = true
        this.currentTimelineContents = findTimelineContents
      }

      if (isChange) {
        // 타임라인 컨텐츠가 있으면(With timeline content)
        if (this.currentTimelineContents.type.value === 'QUIZ') {
          // 퀴즈(quiz)
          this.isTimelineQuiz = true
          this.isTimelineResource = false
        } else { //파일(resource)
          this.isTimelineQuiz = false
          this.closeQuizDetail()
          this.isTimelineResource = true
        }
      }


    },

    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: this.slideFiles.length,
        current: this.currentSlide,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId
      }
      return params
    },

    // update likes count
    updateLikesCount(data) {
      this.likes = data.likes
      this.likesCount = data.likesCount
    },

    // update bookmark count
    updateBookmarkCount(data) {
      this.clipping = data.clipping
      this.clippingCount = data.clippingCount
    },


    // 학습 목록 API 호출(get lesson list)
    fetchLectureList() {
      let responseData = null
      let params = this.setParams()

      //차시 정보
      learnApi.learnViewCourses(params).then((response) => {
        // 과정의 차시 정보만 병합
        // Merging only lesson data from the course
        _.each(response.data.data, (course) => {
          this.lessonsList = this.lessonsList.concat(course.lessons)
        })

        // 다음 차시명 설정(set next lesson)
        let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
          return lesson.progressionId === this.currentProgressionId
        })
        let nextLessonIndex = this.lessonsList.length > 1 && this.lessonsList.length > currentLessonIndex ? currentLessonIndex += 1 : -1
        if (nextLessonIndex) {
          this.nextLesson = this.lessonsList[nextLessonIndex]
          if (nextLessonIndex === -1) {
            this.nextLessonName = this.$t('1999')
          } else {
            if (typeof (this.lessonsList[nextLessonIndex]) != "undefined") {
              this.nextLessonName = this.lessonsList[nextLessonIndex].name
            } else {
              this.nextLessonName = this.$t('1999')
            }

          }
        }

      }).catch((err) => {
      })
    },

    // 가로모드 전체 보기 스크롤 이동(Landscape mode move scroll)
    moveScrollVerticalList(index) {
      let element = this.$refs.verticalSlide[index]
      let options = {
        container: this.$refs.verticalList,
        easing: 'ease-in'
      }
      this.$scrollTo(element, 500, options)
    },

    //(Go to my learning details)
    moveLearnView() {
      let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
      let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
      if (goBackBookMarkLessson == 'setVideoBookMarkLesson') {
        localStorage.removeItem('videoBookMarkLesson');
        this.$router.push({
          name: 'BookMarkedLesson'
        })
      } else if (goBackLikeLessson == 'setVideoLikeLesson') {
        localStorage.removeItem('videoLikeLesson');
        this.$router.push({
          name: 'LikedLesson'
        })
      } else {
        this.$router.push({
          name: 'LearnView',
          params: {learnId: this.$route.params.learnId},
          query: this.$route.query
        })
      }
    },

    moveLearnViewClose() {

      let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
      let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
      if (goBackBookMarkLessson == 'setVideoBookMarkLesson') {
        localStorage.removeItem('videoBookMarkLesson');
        this.$router.push({
          name: 'BookMarkedLesson'
        })
      } else if (goBackLikeLessson == 'setVideoLikeLesson') {
        localStorage.removeItem('videoLikeLesson');
        this.$router.push({
          name: 'LikedLesson'
        })
      } else if (typeof (this.$route.query.questionChatType) != 'undefined') {
        this.$router.push({
          name: 'LearnView',
          params: {learnId: this.$route.params.learnId},
          query: {status: this.$route.query.status, tab: 'ViewQuestion'}
        })
      } else {
        this.$router.push({
          name: 'LearnView',
          params: {learnId: this.$route.params.learnId},
          query: this.$route.query
        })
      }


    },
    takeSurvey(id, respondentId, surveyDistributionType) {
      let params = {
        distId: id,
        respondentId: respondentId,
      }

      this.$router.push({
        name: 'IndependentSurveyIntro',
        params: params,
        query: {
          status: this.$route.query.status,
          learnId: this.$router.currentRoute.params.learnId,
          distributionType: surveyDistributionType
        }
      })
    },


    async onToggleQuiz() {
      if (this.isTimelineResource) {
        this.isTimelineResource = false
        await this.onToggleResource()
      }

      return new Promise(resolve => {
        const elementBody = document.querySelector('body')
        this.isTimelineQuiz = false

        if (!elementBody.classList.contains('quiz-overlay')) {
          this.mainTransitionName = 'slide-up'
          elementBody.classList.add('quiz-overlay')
          this.isQuizVisible = true
          this.isTimeline = true
          resolve()

        } else {
          this.mainTransitionName = 'slide-up'
          this.isQuizVisible = false

          setTimeout(() => {
            elementBody.classList.remove('quiz-overlay')
            this.isTimeline = false
            resolve()
          }, 500)
        }
      })
    },

    async onToggleResource() {
      if (this.isQuizVisible) {
        this.isTimelineQuiz = false
        this.isQuizVisible = false
        await this.onToggleQuiz()
      }

      return new Promise(resolve => {
        const elementBody = document.querySelector('body')

        if (!elementBody.classList.contains('quiz-overlay')) {
          this.mainTransitionName = 'slide-up'
          if (this.isPortrait) {

          }
          elementBody.classList.add('quiz-overlay')
          this.isResourceVisible = true
          resolve()

        } else {
          this.mainTransitionName = 'slide-up'

          this.isResourceVisible = false
          setTimeout(() => {
            elementBody.classList.remove('quiz-overlay');
            resolve()
          }, 500);
        }
      })

    },

    closeResource() {
      this.closeResourcePopup();
    },

    // 타임라인 퀴즈 팝업 닫기(Close the timeline quiz popup)
    closeQuizPop() {
      this.isTimelineQuiz = false
      this.isTimeline = false
    },

     // 타임라인 퀴즈 상세 보기(View detailed timeline quiz)
     async openQuizDetail() {
      this.isTimelineQuiz = false;
      const elementBody = document.querySelector('body');
      elementBody.classList.add('quiz-overlay');
      this.mainTransitionName = 'slide-up';
      this.isTimelineQuiz = false;
      this.isQuizVisible = true;
      this.isTimeline = true;
    },

    // 질문하기로 이동(Go to Ask a Question)
    moveQuestion() {
      this.$router.push({
        name: 'LessonViewQuestion',
        query: this.$route.query
      })
    },
    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },

    async getExamInfo() {
			const params = this.setParams();
			try {
				const result = await learnApi.learnViewExams(params);
				if (result && result.data.data && result.data.data.length === 0) {
					this.isConsistExam = false;
				}
			} catch (error) {
				console.log("GET EXAM ERROR : ", error);
			}
		},
  }
}
</script>
<!--<style scoped src="../../css/slide.css"></style>-->
<style scoped>
#studyContainer #wrap-slide-contents {
  overflow: hidden;
}

span.video-watermark {
  position: absolute;
  /* left: 20px; */
  font-size: 12px;
  transform: rotate(-45deg);
  opacity: 0.25;
  cursor: none;
  z-index: 99;
}

/* span.video-watermark.light {
	color: var(--DocumentWhite);
	left: 50px;
	bottom: 100px;
} */
/* span.video-watermark.dark {
	color: var(--HeadlineBlack);
	bottom: 100px;
	left: 20px;
} */
span.video-watermark.light {
  color: var(--DocumentWhite);
  top: 50%;
  left: 40%;
  transform: translate(-40%, -50%) rotate(-45deg);
}

html[dir="rtl"] span.video-watermark.light {
  right: 40%;
}

span.video-watermark.dark {
  color: var(--HeadlineBlack);
  top: 50%;
  left: 51%;
  transform: translate(-51%, -50%) rotate(-45deg);
}

html[dir="rtl"] span.video-watermark.dark {
  right: 51%;
}

@media (min-width: 480px) {
  span.video-watermark.light {
    left: 45%;
    transform: translateX(-45%) rotate(-45deg);
  }

  html[dir="rtl"] span.video-watermark.light {
    right: 45%;
    transform: translateX(-45%) rotate(-45deg);
  }
}

#playlistContainer.show {
  z-index: 999;
}

.bg-dark1 {
  background-color: #1b232b;
}

.bg-divider {
  background: rgba(206, 218, 220, 0.2) !important;
}

.t-color-gray9 {
  color: var(--ContentVariationInactive) !important;
}

.content-box {
  min-height: calc(100vh - 209px);
}

.font-13 {
  font-size: 13px !important;
}

/* .paging {
opacity: 0.6;
} */
.paging.active {
  opacity: 1;
}

.swiper-wrapper {
  align-items: center !important;
}

.swiper-slide {
  width: 88%;
}

.portrait-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
}

.likeVideo.active {
  color: var(--ContentRed) !important;
}

.addBookmark.active {
  color: var(--ContentBlue) !important;
}

@media (orientation: landscape) {
  .portrait-view {
    display: none;
  }

  body:not(.all-pages) #videoContainer > #verticalList {
    width: 145px;
    position: absolute;
    right: 0;
    /* display: block !important; */
    padding-right: 50px;
    padding-left: 15px;
  }

  html[dir="rtl"] body:not(.all-pages) #videoContainer > #verticalList {
    left: 0;
    padding-left: 50px;
    padding-right: 15px;
  }

  #videoContainer.full-image #wrap-slide-contents .slide-list img {
    object-fit: cover !important;
  }

  #videoContainer > #verticalList > ul {
    overflow-y: scroll;
    height: 75vh;
  }

  #videoContainer .w-full.custom-width {
    width: calc(100% - 210px) !important;
  }
}

.home-progressbar {
  position: absolute;
  height: 4px;
  background: var(--Saleline);

}

.disAbledPlusAndMinus {
  opacity: 0.5
}

.intro-button.position-absolute {
  right: 10px;
  bottom: 10%;
  z-index: 9999;
}

html[dir="rtl"] .intro-button.position-absolute {
  left: 10px;
}

/* .slide-list img {
  height: auto;
} */
</style>
